import navInit from './nav';
import sliderInit from './slider';
import filterInit from './filter';
import tooltipInit from './tooltip';
import searchInit from './search';
import scrollInit from './scroll';
import langInit from './lang';

document.addEventListener('DOMContentLoaded', () => {
	navInit();
	sliderInit();
	filterInit();
	tooltipInit();
	searchInit();
	scrollInit();
	langInit();
});
